import styled from 'styled-components';

import { FONT_WEIGHT } from 'core/styles/fonts';
import * as mx from 'core/styles/mixins';
import * as vr from 'core/styles/variables';

// ------------------------------------
// Shared component styles

export const Ul = styled.ul`
	${mx.listReset}

	&& > li {
		margin: 0;
		a {
			color: ${({ theme }) =>
				theme.global.page.authenticatedHeader.subItems.desktop.fontColor};
			padding: 12px 28px;
			font-size: ${vr.formfieldFontSize};
			font-weight: ${FONT_WEIGHT.LIGHT};
			border-left: 3px solid transparent;
			height: 56px;
		}

		a:hover {
			color: ${({ theme }) =>
				theme.global.page.authenticatedHeader.subItems.fontColor};
			background-color: ${({ theme }) =>
				theme.global.page.authenticatedHeader.subItems.color};
		}
	}
`;

export const Pill = styled.span`
	background-color: ${({ theme }) =>
		theme.global.page.authenticatedHeader.notifications.pill.color};
	color: ${vr.brandWhite};
	border-radius: 24px;
	padding: 0;
	margin-right: 0;
	margin-left: 5px;
	min-width: 23px;
	font-size: ${vr.formfieldHelpTextFontSize};
`;
